import React, { useState } from 'react';
import { useMutation } from '@apollo/react-hooks';
import { INSURANCE_LEAD } from '../../graphql';
import {
    Container, Area, Holder,
    Info, ShieldWhite, InfoTitle,
    Form, FormTitle, FormSubText, Names, NarrowTextInput, WideTextInput, Row,
    CheckBox, CheckBoxLabel, Error, CTAButton, Cancel,
    Thanks, HeartIcon, ThanksTitle, ThanksText, TanksButton,
} from './LeaveDetails.style';

const InfoComp = ({ title }) => (
    <Info>
        <ShieldWhite />
        {!!title && <InfoTitle>{title.text}</InfoTitle>}
    </Info>
);

const validateForm = (first, last,  phoneNumber, termsAccepted, content) => {
    const { phoneEror, missingFields } = content;

    if (first.length < 2) {
        return { type: 'first', text: missingFields.text };
    } else if (last.length < 2) {
        return { type: 'last', text: missingFields.text };
    } else if (phoneNumber.length < 9) {
        return { type: 'phone', text: phoneEror.text };
    } else if (!termsAccepted) {
        return { type: 'terms', text: missingFields.text };
    }
};

export const LeaveDetails = ({ content, setFormActive }) => {
    const [done, setDone] = useState(false);
    const [error, setError] = useState('');
    const [first, setFirst] = useState('');
    const [last, setLast] = useState('');
    const [emailAddress, setEmailAddress] = useState('');
    const [phoneNumber, setPhoneNumber] = useState('');
    const [termsAccepted, setTermsAccepted] = useState(true);
    const [insuranceLead] = useMutation(INSURANCE_LEAD);

    const {
        title, subtitle, text,
        fields: {
            approveTerms,
            cancel,
            cta,
            email,
            firstName,
            lastName,
            phone,
        },
        thanks: {
            title: thanksTitle,
            back,
            text: thanksText,
        },
    } = content;

    return (<Container>
        <Area>
            {!done ? <Holder>
                <InfoComp title={title} />
                <Form onSubmit={(e) => {
                    e.preventDefault();
                    const err = validateForm(first, last, phoneNumber, termsAccepted, content.fields);

                    if (err) {
                        setError(err.text);
                    } else {
                        insuranceLead({
                            variables: {
                                firstName: first,
                                lastName: last,
                                email: emailAddress,
                                phone: phoneNumber,
                            },
                        });

                        setFirst('');
                        setLast('');
                        setEmailAddress('');
                        setPhoneNumber('');
                        setDone(true);
                    }
                }}>
                    {!!subtitle && <FormTitle>{subtitle.text}</FormTitle>}
                    {!!text && <FormSubText>{text.text}</FormSubText>}
                    <Names>
                        <NarrowTextInput
                            placeholder={firstName.text}
                            value={first}
                            onChange={({ target: { value } }) => {
                                setFirst(value);
                                setError('');
                            }}
                        />
                        <NarrowTextInput
                            placeholder={lastName.text}
                            value={last}
                            onChange={({ target: { value } }) => {
                                setLast(value);
                                setError('');
                            }}
                        />
                    </Names>
                    <WideTextInput
                        placeholder={phone.text}
                        value={phoneNumber}
                        onChange={({ target: { value } }) => {
                            setPhoneNumber(value);
                            setError('');
                        }}
                    />
                    <WideTextInput
                        placeholder={email.text}
                        value={emailAddress}
                        onChange={({ target: { value } }) => {
                            setEmailAddress(value);
                            setError('');
                        }}
                    />
                    <Row>
                        <CheckBox
                            onClick={() => setTermsAccepted(!termsAccepted)}
                            active={termsAccepted}
                        />
                        <CheckBoxLabel
                            target='_blank'
                            href='/terms'
                        >{approveTerms.text}</CheckBoxLabel>
                    </Row>
                    <Error>{error}</Error>
                    <CTAButton>{cta.text}</CTAButton>
                    <Cancel onClick={() => setFormActive(false)}>{cancel.text}</Cancel>
                </Form>
            </Holder> :
                <Thanks>
                    <HeartIcon />
                    <ThanksTitle>{thanksTitle.text}</ThanksTitle>
                    <ThanksText>{thanksText.text}</ThanksText>
                    <TanksButton onClick={() => setFormActive(false)}>{back.text}</TanksButton>
                </Thanks>}
        </Area>
    </Container>);
};